module.exports = __webpack_public_path__ + "img/85800.25975122.jpg";